/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

export const attachmentTypes = {
  healthEntry: 'health_entry',
  healthEntryValue: 'health_entry_value',
  file: 'file',
  note: 'note',
  contact: 'contact',
  trackable: 'trackable',
  trackableObservation: 'trackable_observation',
  none: '',
};

const compatibleAttachmentTypes = {
  [attachmentTypes.healthEntry]: [attachmentTypes.file, attachmentTypes.note, attachmentTypes.contact],
  [attachmentTypes.healthEntryValue]: [attachmentTypes.file, attachmentTypes.note, attachmentTypes.contact],
  [attachmentTypes.file]: [attachmentTypes.note, attachmentTypes.contact],
  [attachmentTypes.note]: [attachmentTypes.contact],
  [attachmentTypes.none]: [],
};

class AttachmentModel {

  constructor(data = {}) {
    this.data = _.assign({
      parent: {},
      attachment: {},
    }, data);
  }

  setParent(id, type) {
    this.data.parent = {
      id,
      type,
    };
  }

  setAttachment(id, type) {
    this.data.attachment = {
      id,
      type,
    };
  }

  setParentInstance(instance) {
    this.parent = instance;
  }

  setAttachmentInstance(instance) {
    this.attachment = instance;
  }

  allowsAttachment(type) {
    const types = this.data.parent.type ? compatibleAttachmentTypes[this.data.parent.type] : [];
    return _.includes(types, type);
  }

}

export default AttachmentModel;
